import ArrowLeftContainer from '@components/atoms/container/channelListEventArrowLeftContainer';
import ArrowLeftIcon from '@components/atoms/icons/arrowLeft';
import ArrowRightContainer from '@components/atoms/container/channelListEventArrowRightContainer';
import ArrowRightIcon from '@components/atoms/icons/arrowRight';
import ChannelListContext from '@shared/components/utils/context/channelListContext';
import ChannelListCrew from './channelListCrew';
import ChannelListPosterContainer from '@components/atoms/container/channelListPosterContainer';
import ChannelListServices from './channelListServices';
import ChannelListSynopsisMainContainer from '@components/atoms/container/channelListSynopsisMainContainer';
import ChannelListSynopsisLeftContainer from '@components/atoms/container/channelListSynopsisLeftContainer';
import ChannelListSynopsisRightContainer from '@components/atoms/container/channelListSynopsisRightContainer';
import ChannelListSynopsisText from '@components/atoms/text/channelListSynopsisText';
import Focus from '@shared/types/enums/focus';
import LowPoster from '@components/atoms/images/lowPoster';
import LowPosterDefault from '@shared/assets/images/png/lowPosterDefault.png';
import Poster from '@components/atoms/images/poster';
import PosterDefault from '@shared/assets/images/png/posterDefault.png';
import TranslationManager from '@shared/assets/locale/translationsManager';
import { focusSelector } from '@shared/store/slices/focus.slice';
import { useAppSelector } from '@shared/store/hooks';
import { useContext, useMemo } from 'react';
import { userSelector } from '@shared/store/slices/user.slice';

export default function ChannelListSynopsis() {
  const { parental } = useAppSelector(userSelector);
  const { focus } = useAppSelector(focusSelector);
  const { event, focused, futureEvents, pastEvents } =
    useContext(ChannelListContext);

  const { lowPoster, poster, parentalControl, score, synopsis } =
    useMemo(() => {
      const lowPoster = event?.lowPoster || LowPosterDefault;
      const parentalControl =
        (parental?.enabled && event?.channel?.parentalControl) ?? false;
      const poster = event?.poster || PosterDefault;
      const score = event?.score;
      const synopsis = event?.synopsis;
      return {
        parentalControl,
        lowPoster,
        poster,
        score,
        synopsis,
      };
    }, [event, parental, futureEvents, pastEvents]);

  const { animation, display } = useMemo(() => {
    const animation = {
      arrowLeft: focused ? 'arrow-fade-in' : 'arrow-fade-out',
      arrowRight: focused ? 'arrow-fade-in' : 'arrow-fade-out',
    };
    const canDisplay = focus === Focus.CHANNEL_LIST_EVENTS && !parentalControl;
    const display = {
      arrowLeft: pastEvents ? (canDisplay ? 1 : 0.3) : 0,
      arrowRight: futureEvents ? (canDisplay ? 1 : 0.3) : 0,
    };
    return { animation, display };
  }, [event, focus, focused, futureEvents, pastEvents, parentalControl]);

  return (
    <>
      <ChannelListSynopsisMainContainer id={'channelListSynopsisContainer'}>
        <ChannelListSynopsisLeftContainer>
          {/* Poster */}
          <ChannelListPosterContainer>
            <LowPoster width={200} height={300} src={lowPoster} />
            <Poster width={200} height={300} src={poster} />
          </ChannelListPosterContainer>
          {/* Services */}
          <ChannelListServices score={score} />
        </ChannelListSynopsisLeftContainer>
        {/* Synopsis and crew */}
        <ChannelListSynopsisRightContainer
          animation={'channel-list-content'}
          focused={focused}
        >
          {parentalControl ? (
            <ChannelListSynopsisText bold={true} id={'moreSynopsisText'}>
              {TranslationManager.get('MISC.MORE')}
            </ChannelListSynopsisText>
          ) : (
            <>
              <ChannelListSynopsisText id={'synopsisText'}>
                {synopsis}
              </ChannelListSynopsisText>
              <ChannelListCrew />
            </>
          )}
        </ChannelListSynopsisRightContainer>
      </ChannelListSynopsisMainContainer>
      {/* Synopsis left arrow */}
      <ArrowLeftContainer
        animation={animation.arrowLeft}
        opacity={display.arrowLeft}
      >
        <ArrowLeftIcon color={'#FFFFFF'} width={25} height={35} />
      </ArrowLeftContainer>
      {/* Synopsis right arrow */}
      <ArrowRightContainer
        animation={animation.arrowRight}
        opacity={display.arrowRight}
      >
        <ArrowRightIcon color={'#FFFFFF'} width={25} height={35} />
      </ArrowRightContainer>
    </>
  );
}
